export default __webpack_public_path__ + "images/ekart_logistics_logo.png";